import React, { useState, useEffect } from "react";
import Image from "./Image";
import classes from "./PDFSlider.module.css";
import CustomButton from "./CustomButton";
import { useTranslation } from "react-i18next";

import printIcon from "../assets/printer_icon.png";
import PDFViewer from "./PDFViewer";
import AreYouSureModal from "./AreYouSureModal";
import useRequest from "../utils/useRequest";

const DIRECTION = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
};

const AllDocumentsSlider = ({
  documents,
  setDocuments,
  direction = DIRECTION.HORIZONTAL,
  title,
  mode,
}) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [deleteModal, setDeleteModal] = useState({
    visible: false,
    documentId: "",
  });
  const { t } = useTranslation("general");

  const {
    success: successfullyDelete,
    loading: deleteLoading,
    refetch,
  } = useRequest(
    `/deleteDocument/${deleteModal.documentId}`,
    "DELETE",
    {},
    null,
    false
  );

  const openModal = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const handlePrint = async () => {
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
        <html>
          <head>
            <title>${t("print_image")}</title>
          </head>
          <body>
            <img style="max-width: 100%; max-height: 100vh" src="${selectedImage}" alt="Image for printing" onload="window.print();" />
          </body>
        </html>
      `);
    printWindow.document.close();
  };

  const handleDeleteDocument = () => {
    refetch();
  };

  useEffect(() => {
    if (successfullyDelete) {
      // console.log("documents", documents);
      // console.log("documentID", deleteModal.documentId);
      const updatedDocuments = documents?.filter(
        (doc) => doc?.id !== deleteModal.documentId
      );
      setDocuments(updatedDocuments);
      setDeleteModal({ visible: false, documentId: "" });
    }
  }, [successfullyDelete]);

  return (
    <div className={classes.sliderContainer}>
      {title !== "noTitle" ? <span>{t(title)}: </span> : ""}
      <div
        className={
          direction === DIRECTION.HORIZONTAL
            ? classes.pdfSliderHorizontal
            : classes.pdfSliderVertical
        }
      >
        {documents?.length === 0 ? (
          <span className="not-found">{t("noDocuments")}</span>
        ) : null}
        {documents?.map((document, index) => {
          if (document.mime_type === "application/pdf") {
            return (
              <div className={classes.document} key={index}>
                <div className={classes.sliderImage}>
                  <PDFViewer
                    fileId={document?.id}
                    filePath={document?.path}
                    fileName={document?.name}
                    mode={mode}
                    setDeleteModal={setDeleteModal}
                  />
                </div>
                <span className={classes.fileName}>{document?.name}</span>
              </div>
            );
          } else {
            if (document?.path)
              return (
                <div className={classes.document} key={index}>
                  <Image
                    imagePath={document?.path}
                    fileId={document?.id}
                    fileName={document?.name}
                    className={classes.sliderImage}
                    onClick={openModal}
                    mode={mode}
                    setDeleteModal={setDeleteModal}
                  />
                  <span className={classes.fileName}>{document?.name}</span>
                </div>
              );
          }
        })}
      </div>
      {selectedImage && (
        <div className={classes.overlay}>
          <div className={classes.modal}>
            <div className={classes.modalHeader}>
              <span className={classes.close} onClick={closeModal}>
                &times;
              </span>
            </div>
            <div className={classes.modalBody}>
              <img
                className={classes.modalContent}
                src={selectedImage}
                alt="Selected"
              />
            </div>
            <div className={classes.modalFooter}>
              <CustomButton
                title={t("print")}
                onClick={handlePrint}
                variant="gray"
                icon={printIcon}
                iconSize={18}
              />
            </div>
          </div>
        </div>
      )}{" "}
      {deleteModal.visible ? (
        <AreYouSureModal
          onClose={() => setDeleteModal({ visible: false, documentId: "" })}
          onConfirm={handleDeleteDocument}
          customMessage="areYouSureDeleteMessage"
          closeTitle="cancel"
          confirmTitle="delete"
          loading={deleteLoading}
        />
      ) : null}
    </div>
  );
};

export default AllDocumentsSlider;
